import { Link } from 'react-router-dom';
import { ArrowLeft, Check, Star } from 'lucide-react';

const PLANS = [
  {
    id: 'FREE',
    name: 'Gratuito',
    price: 0,
    priceText: 'Gratis',
    color: 'gray',
    features: [
      '5 productos publicados',
      'Acceso básico a la plataforma',
      'Soporte por email',
      'Sin ubicación en el mapa'
    ],
    limitations: [
      'Sin marca de vendedor verificado',
      'Sin productos destacados',
      'Sin estadísticas avanzadas'
    ]
  },
  {
    id: 'PRO',
    name: 'Pro',
    price: 5000,
    priceText: '₡5,000/mes',
    color: 'blue',
    popular: false,
    features: [
      '20 productos publicados',
      'Mayor visibilidad en búsquedas',
      'Vendedor verificado ✓',
      'Ubicación en el mapa',
      'Estadísticas básicas',
      'Soporte prioritario'
    ],
    limitations: [
      'Sin badge de vendedor destacado',
      'Sin productos ilimitados'
    ]
  },
  {
    id: 'PREMIUM',
    name: 'Premium',
    price: 15000,
    priceText: '₡15,000/mes',
    color: 'orange',
    popular: true,
    features: [
      'Productos ilimitados',
      'Máxima visibilidad en búsquedas',
      'Vendedor verificado ✓',
      'Ubicación en el mapa',
      'Estadísticas completas',
      'Badge de vendedor destacado ⭐',
      'Productos destacados',
      'Soporte VIP'
    ],
    limitations: []
  }
];

export default function SubscriptionPlans() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 py-8">
        <Link to="/" className="flex items-center gap-2 text-primary mb-6 hover:underline">
          <ArrowLeft className="w-5 h-5" />
          Volver al inicio
        </Link>

        <h1 className="text-3xl font-black mb-2">
          <span className="text-primary">Planes de</span> Suscripción
        </h1>
        <p className="text-gray-600 mb-8">Elige el plan que mejor se adapte a tu negocio</p>

        <div className="grid md:grid-cols-3 gap-6">
          {PLANS.map(plan => {
            const colorClasses = {
              gray: 'border-gray-300 bg-white',
              blue: 'border-blue-500 bg-white',
              orange: 'border-orange-500 bg-gradient-to-b from-orange-50 to-white'
            };
            const buttonClasses = {
              gray: 'bg-gray-600 hover:bg-gray-700',
              blue: 'bg-blue-600 hover:bg-blue-700',
              orange: 'bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600'
            };
            const badgeClass = {
              gray: 'bg-gray-500',
              blue: 'bg-blue-500',
              orange: 'bg-gradient-to-r from-yellow-500 to-orange-500'
            };

            return (
              <div
                key={plan.id}
                className={`rounded-2xl border-2 p-6 ${colorClasses[plan.color]} ${plan.popular ? 'ring-4 ring-primary/20' : ''}`}
              >
                {plan.popular && (
                  <div className="flex justify-center mb-2">
                    <span className={`${badgeClass[plan.color]} text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1`}>
                      <Star className="w-3 h-3" />
                      Más Popular
                    </span>
                  </div>
                )}
                
                <h2 className={`text-2xl font-bold mb-1 ${plan.id === 'FREE' ? 'text-gray-700' : 'text-primary'}`}>
                  {plan.name}
                </h2>
                
                <div className="mb-4">
                  <span className={`text-3xl font-black ${plan.id === 'FREE' ? 'text-gray-700' : 'text-primary'}`}>
                    {plan.priceText}
                  </span>
                </div>

                <div className="space-y-3 mb-6">
                  <p className="font-semibold text-gray-700">Incluye:</p>
                  {plan.features.map((feature, i) => (
                    <div key={i} className="flex items-start gap-2 text-sm text-gray-600">
                      <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                {plan.limitations.length > 0 && (
                  <div className="space-y-2 mb-6 pt-4 border-t border-gray-200">
                    <p className="font-semibold text-gray-500 text-sm">Sin:</p>
                    {plan.limitations.map((lim, i) => (
                      <div key={i} className="flex items-start gap-2 text-sm text-gray-400">
                        <span className="w-5 h-5 flex-shrink-0 text-center">✗</span>
                        <span>{lim}</span>
                      </div>
                    ))}
                  </div>
                )}

                <Link
                  to="/register"
                  className={`block w-full text-center text-white font-bold py-3 rounded-xl transition ${buttonClasses[plan.color]}`}
                >
                  Empezar con {plan.name}
                </Link>
              </div>
            );
          })}
        </div>

        <div className="mt-8 bg-blue-50 rounded-2xl p-6">
          <h3 className="font-bold text-lg mb-3 text-blue-800">💳 Métodos de pago</h3>
          <p className="text-blue-700">
            Por el momento, los pagos se procesan manualmente. Contáctanos para activar tu plan PRO o PREMIUM.
          </p>
        </div>

        <div className="mt-6 text-center">
          <p className="text-gray-500">
            ¿Dudas sobre qué plan elegir?{' '}
            <Link to="/contact" className="text-primary font-semibold hover:underline">
              Contáctanos
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
